import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { addNewCustomFabricAtom } from '../../state';

interface DetailsProps {
    title: string;
    code: string;
    designer: {
        name: string;
    };
    categories: {
        name: string;
    }[];
}

const Details: React.FC<DetailsProps> = ({
    title, code, designer, categories
}) => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [addNewCustomFabric, setAddNewCustomFabric] = useRecoilState(addNewCustomFabricAtom)
    return (
        <div className="flex flex-col gap-1">
            <div>
                <h1 className="text-2xl md:text-3xl font-medium text-gray-900 mb-2">
                    {title}
                </h1>
                <p className="text-sm text-gray-500">{code}</p>
            </div>

            <div>
                <p className="text-md font-medium mb-1">Designed by</p>
                <p className="text-sm text-gray-600">
                    {designer.name}
                </p>
            </div>

            <div className="flex items-center gap-2">
                <hr color='black' />
                <p className="text-md font-medium mb-0">Categories:-</p>
                <div className="flex gap-3">
                    {categories?.map((category, index) => (
                        <button key={index} className="pb-[0.3rem] border border-gray-300 text-gray-800 px-3 rounded-md font-medium transition-all hover:bg-gray-50">
                            {category?.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex gap-4 mt-4">
                <button onClick={() => {
                    setAddNewCustomFabric([]);
                    navigate(`/products/product-detail/${id}`)
                }} className="bg-black text-white p-2 rounded-md font-medium transition-all hover:bg-gray-800 flex-1">
                    Configurator
                </button>
                {/* <button className="border border-dark text-gray-800 p-2 rounded-md font-medium transition-all hover:bg-gray-50 flex-1">
                    Add to Selection
                </button> */}
            </div>
        </div>
    );
};

export default Details;